const defaultUiConfig = {
    name: 'Value Sets',
    withActions: [],
    primaryKey: 'valueSetId',
    pageSize: 10,
    properties: {
        // oid: {
        //     sortable: true,
        //     name: 'Oid',
        //     rowDisplay: false
        // },
        name: {
            name: 'Name',
            sortable: true,
            rowDisplay: true
        },
        code: {
            name: 'Code',
            sortable: true,
            nullable: false,
            rowDisplay: true
        },
        version: {
            name: 'Version',
            sortable: true,
            rowDisplay: true
        }
    }
};

export default defaultUiConfig;
